import React from 'react';
import PageLayout from "../../components/PageLayout/PageLayout";
import '../bookpage.css'
import Title from '../../components/Title/Title';

export default function Rededicate() {
  return (
    <PageLayout>
      <div className="book-page">
        <Title title="Rededicate yourself to God as a living sacrifice" />
        <blockquote>“I urge you therefore, brethren, by the mercies of God, to present your bodies a living and holy sacrifice, acceptable to God, which is your spiritual service of worship.” (Romans 12:1)</blockquote>

        <p>Sometimes we sin because we view ourselves as in control and in charge. Driven by our own agenda about what we want to do, we make mistakes and sin because we have not submitted ourselves fully to the Lord. God calls us to present ourselves to Him as a living sacrifice, something which is given up and consumed for His purposes. This implies that we surrender our plans and desires to the Lord, every aspiration and interest, every goal and pursuit. Selfish ambition is said to lead to disorder and “every evil thing” (James 3:13-16), and yet if we are honest with ourselves, and really ask ourselves why we do the things we do and what motivates us, we will find plenty of selfish ambition, the very thing that will cause us to stumble time and again. The next step, then in overcoming temptation, is to consider yourself as a sacrifice to God, dead to self interests and goals, and then take up your cross daily to follow Jesus. Listen for His leading, and do what He wants done. There are no free people; you are either a slave to sin or a slave to righteousness (Romans 6:16-20). Rededicate your life to Christ and His service, and surrender to Him all ambitions, goals, and plans. Learn to listen and replace your interests and desires with God’s. This will help you overcome the many sins which result from self-centeredness and selfish ambition. It’s not about you; it’s all about Christ.</p>

        <ul>
          <li><strong>Present your members as instruments of righteousness to God.</strong><br />
            <em>Romans 6:12-14, 12:1-2</em>
          </li>

          <li><strong>Consider yourself a slave to God, not free to do as you please.</strong><br />
            <em>Romans 6:15-20, Galatians 5:17</em>
          </li>

          <li><strong>Submit yourself wholeheartedly to learn and do the will of God.</strong><br />
            <em>Psalm 40:8, Hebrews 10:7, 36, James 4:7-8, 1 Peter 2:15</em>
          </li>

          <li><strong>Put Christ’s interests above your own.</strong><br />
            <em>Philippians 2:20-21</em>
          </li>

          <li><strong>Seek first His kingdom and His righteousness with diligence.</strong><br />
            <em>Psalm 119:4, Matthew 6:33, 2 Peter 1:5-11</em>
          </li>

          <li><strong>Make it your ambition to please Jesus Christ; be the faithful slave.</strong><br />
            <em>Matthew 24:45-51, John 8:29, 2 Corinthians 5:9-10, Colossians 1:10, 1 John 3:22</em>
          </li>

          <li><strong>Consider yourself expendable for the Kingdom of God; fight the good fight.</strong><br />
            <em>2 Timothy 4:6-7</em>
          </li>
        </ul>

      </div>
    </PageLayout>
  );
};
